import { render, staticRenderFns } from "./MediaRecommendations.vue?vue&type=template&id=a75ffad4&scoped=true&"
import script from "./MediaRecommendations.vue?vue&type=script&lang=js&"
export * from "./MediaRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75ffad4",
  null
  
)

export default component.exports